import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { tap, timeout } from 'rxjs/operators';
import { EventManager } from 'src/app/core/services';
declare let $;
@Injectable({ providedIn: 'root' })
export class ExecuteBeforeRequestInterceptor implements HttpInterceptor {
  private readonly SERVER_API_URL: any;
  extra: any;
  quanlity: any = 0;
  singleAPIs: any = {};
  modalRef: any;
  isLoad: boolean = false;
  ignoreAPIS: any = [];
  constructor(
    private eventManager: EventManager,
  ) {
  }
  defaultTimeout = 180 * 1000;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpResponse<any>> {
    const timeoutValue = request.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    let splits = request.url.split('/');
    let api = '';
    splits.forEach((item, index) => {
        if (index > 2 && !parseInt(item)) {
            api += '/' + item;
        }
    })
    this.beforeRequest(api);
    return next.handle(request)
    .pipe(
      timeout(timeoutValueNumeric),
      tap(
        (res: HttpResponse<any>) => {
          if (res.status) {
            this.hideSpinner(api);
          }
        },
        (err: any) => {
          this.hideSpinner(api);
          return err;
        },
      ),
    )
  }
  checkIgnoreAPI(api) {
    this.ignoreAPIS = (this.ignoreAPIS.length  ?  this.ignoreAPIS :  JSON.parse(sessionStorage.getItem('ignoreAPIS'))) || [];
    return this.ignoreAPIS.some((iapi) => { 
      return api.includes(iapi);
    })
  }
  beforeRequest(api): void {
    if (this.checkIgnoreAPI(api)) {
      return;
    }
    this.quanlity++;
    // console.log('increase quanlity: ' + this.quanlity, api);
    // show spinner
    if (this.isLoad) {
      return;
    }
    this.isLoad = true;
    setTimeout(() => {
      if (!this.isLoad || this.checkIgnoreAPI(api)) {
        return;
      }
      console.log('api load', api);
      this.eventManager.broadcast({
        name: 'show-spinner',
        content: {}
      });
    }, 1000)

    // after 10s auto close spinner
    setTimeout(() => {
      if (this.isLoad) {
        this.hideSpinner(api);
      }
    }, 1000 * 10)
  }
  hideSpinner(api) {
    if (this.checkIgnoreAPI(api)) {
      return;
    }
    this.quanlity--;
    // console.log('decrease quanlity: ', this.quanlity);
    // close spinner
    if (this.quanlity <= 0) {
      this.isLoad = false;
      this.eventManager.broadcast({
        name: 'close-spinner',
        content: {}
      })
    }
  }
}
